import React from "react";
import { skills } from "../data/data";

export default function Skills() {
    return (
        <section id="skills">
            <div className="container px-5 py-10 mx-auto">
                <div className="text-center mb-20">
                    <i className="fa-regular fa-keyboard m-3 fa-beat-fade" style={{ color: "#63E6BE", fontSize: "50px" }}></i>
                    <h1 className="sm:text-4xl text-3xl font-medium title-font text-white mb-4">
                        Skills &amp; Technologies
                    </h1>
                    <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
                        All the relevant skills I have aqquired outside of my academic qualifications.
                    </p>
                </div>
                <div className="grid md:grid-cols-2 lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2 justify-center">
                    {skills.map((skill) => (
                        <div key={skill.name} className="p-2 mx-3 flex justify-center">
                            <div className="bg-cyan-950 hover:bg-cyan-800 hover:scale-105 transition-all rounded-full flex px-4 py-2 min-w-full items-center ">
                                {/* <i className="fa-solid fa-circle mr-3"></i> */}
                                <img className="mx-2 rounded-lg h-[40px]" src={skill.logo} alt={skill.name} style={{ maxWidth: "40px" }} />
                                <span className="title-font font-medium text-white">
                                    {skill.name}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}